
import { Component, Vue } from 'vue-property-decorator';
import OsChangePasswordForm from '@/components/shared/password/OsChangePasswordForm.vue';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
@Component({
  components: { OsSheetContent, OsSheet, OsChangePasswordForm }
})
export default class MyProfilePasswordIndex extends Vue {}
